import { writable } from 'svelte/store';
const initialState = {
    title: 'Sermon title',
    fontColor: 'default',
    fontFamily: 'default',
    textAnimation: 'FadeInDown',
    showSubtitles: true,
    showTitle: true,
    brandLogo: '',
    showBrandLogo: true,
    checkIfBrandLogoExists: true,
    music: null,
    musicName: '',
    totalDuration: 0,
    audioLevel: 50,
    videoLevel: 100,
    extraInformation: [],
    isPlaying: false,
    tracking: null,
    videoFade: true,
    restored: false
};
// Init state
const { subscribe, update } = writable(initialState);
const actions = {
    set: (updatedState) => {
        update(store => ({ ...store, ...updatedState }));
    },
    resetState() {
        update(store => ({
            ...store,
            title: 'Sermon title',
            fontColor: 'default',
            fontFamily: 'default',
            textAnimation: 'FadeInDown',
            showSubtitles: true,
            showTitle: true,
            brandLogo: '',
            showBrandLogo: true,
            checkIfBrandLogoExists: true,
            music: null,
            musicName: '',
            totalDuration: 0,
            audioLevel: 50,
            videoLevel: 100,
            extraInformation: [],
            isPlaying: false,
            tracking: null,
            videoFade: true,
            restored: false
        }));
    }
};
const preview = {
    ...actions,
    subscribe
};
export default preview;
